/** „1 Kandidat", „1.234 Kandidaten": a count with the right form of its noun (#150). */

export interface Noun {
  one: string;
  many: string;
}

export const CANDIDATE_NOUN: Noun = { one: "Kandidat", many: "Kandidaten" };
export const JOB_NOUN: Noun = { one: "Stelle", many: "Stellen" };
export const ENTRY_NOUN: Noun = { one: "Eintrag", many: "Einträge" };
export const HOUR_NOUN: Noun = { one: "Stunde", many: "Stunden" };
export const SEARCH_NOUN: Noun = { one: "Suche", many: "Suchen" };
export const EXTRA_RECRUITER_NOUN: Noun = {
  one: "zusätzlicher Recruiter",
  many: "zusätzliche Recruiter",
};
export const ACTIVE_FILTER_NOUN: Noun = { one: "aktiver Filter", many: "aktive Filter" };

// de-DE leaves four-digit numbers ungrouped by default („1234"); always group them.
const COUNT_FORMAT = new Intl.NumberFormat("de-DE", { useGrouping: "always" });

export function formatCount(n: number): string {
  return COUNT_FORMAT.format(n);
}

/** The noun alone, for a number that's rendered apart from it. */
export function nounFor(n: number, noun: Noun): string {
  return n === 1 ? noun.one : noun.many;
}

export function countLabel(n: number, noun: Noun, options?: { zero?: string }): string {
  if (n === 0 && options?.zero !== undefined) return options.zero;
  return `${formatCount(n)} ${nounFor(n, noun)}`;
}
